import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Badge, Card, Box, Grid } from "@mui/material";
import { useSpring, animated } from "@react-spring/web";

const theme = createTheme({
  // Define your theme customization here
});

interface ImageItem {
  src: string;
  alt: string;
  badgeContent: number;
}

const imageItems: ImageItem[] = [
  { src: "outlook.png", alt: "Outlook", badgeContent: 30 },
  { src: "powerpoint.png", alt: "PowerPoint", badgeContent: 6 },
  { src: "word.png", alt: "Word", badgeContent: 3 },
  { src: "excel.png", alt: "Excel", badgeContent: 4 },
  { src: "crm.png", alt: "Crm", badgeContent: 1 },
  { src: "teams.png", alt: "Teams", badgeContent: 40 },
  { src: "sharepoint.png", alt: "sharepoint", badgeContent: 3 },
  { src: "sms.png", alt: "sms", badgeContent: 3 },

  { src: "calendar.png", alt: "Calendar", badgeContent: 1 },
  { src: "post.png", alt: "Post", badgeContent: 6 },
  { src: "files.png", alt: "Files", badgeContent: 6 },
  { src: "shout.png", alt: "Talk", badgeContent: 3 },

  // Add more items here
];

interface AnimatedCardProps {
  item: ImageItem; // Assuming ImageItem is defined elsewhere as before
  index: number; // Add an index prop
}
const AnimatedCard: React.FC<AnimatedCardProps> = ({ item, index }) => {
  // Apply the animation to a wrapper that includes both the Badge and the Card
  const animationStyle = useSpring({
    from: { transform: "translateY(0px)" },
    to: { transform: "translateY(-30px)" },
    config: { tension: 300, friction: 5 },
    loop: { reverse: true },
    reset: true,
    delay: index * 100, // Delay based on index
  });

  return (
    <Grid item xs={3} key={index}>
      {" "}
      {/* Each card takes up 3/12 of the row, fitting 4 items per row */}
      <animated.div
        style={{
          ...animationStyle,
          width: "30px",
          height: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Badge badgeContent={item.badgeContent} color="primary">
          <Card
            variant="elevation"
            sx={{
              width: "60px", // Set the width of the Card to 60px
              height: "60px", // Set the height of the Card to 60px
              borderRadius: 3,
              display: "flex", // This ensures the content is centered
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              component="img"
              src={item.src}
              alt={item.alt}
              sx={{
                p: 1,
                maxWidth: "100%",
                maxHeight: "100%",
                width: "auto",
                height: "auto",
              }}
            />
          </Card>
        </Badge>
      </animated.div>
    </Grid>
  );
};

const RoundedCard: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        spacing={2}
        sx={{ justifyContent: "center", width: "100%" }}
      >
        {imageItems.map((item, index) => (
          <AnimatedCard key={index} item={item} index={index} /> // Pass index to AnimatedCard
        ))}
      </Grid>
    </ThemeProvider>
  );
};

export default RoundedCard;
